module.exports = __webpack_public_path__ + "static/coph-timeline-24be65dbde54beddb0ad77961e28ef92.jpg";